import { Form, Radio } from 'antd';
import classes from './index.module.css';
import ContentPanel from './ContentPanel';
import Buttons from './Buttons';
import { DESC, TITLE, WIDGET_STATUS_LIST } from './const';

export default function WidgetStatus() {
  // const form = Form.useFormInstance();
  return (
    <ContentPanel title={TITLE.second} desc={DESC.second} step={2}>
      <Form.Item noStyle className={classes.radio_group} name="widget_status">
        <Radio.Group>
          {WIDGET_STATUS_LIST.map(({
            value, label, recommended, desc,
          }) => (
            <div className={classes.radio} key={value}>
              <Radio value={value}>
                <div className={classes.radio_title}>
                  {label}
                  {recommended
                    && <span className={classes.radio_recommended}>{recommended}</span>}
                </div>
              </Radio>
              <div className={classes.radio_desc}>{desc}</div>
            </div>

          ))}

        </Radio.Group>
      </Form.Item>
      <Form.Item>
        <Buttons
          backUrl="../eligible-products"
          nextUrl="../date"
        />
      </Form.Item>

    </ContentPanel>

  );
}
